import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  ar: {
    nav: {
      subTitle: "مستوردون ومصدّرون معتمدون",
      home: "الرئيسية",
      about: "من نحن",
      products: "المنتجات",
      track: "تتبع الشحنة",
      quote: "طلب تسعير",
      contact: "تواصل معنا",
      langBtn: "English",
    },
    hero: {
      badge: "الرائدون في التوريد والاستيراد ⚓",
      title: "حلول متكاملة لاستيراد وتصدير قطع غيار السيارات",
      desc: "نربط تجارتك بأكبر مصانع قطع الغيار العالمية في اليابان، ألمانيا، وكوريا. نوفر شحن مباشر للكميات الكبيرة والجملة بأسعار المصنع وضمان معتمد.",
      btnProducts: "تصفح المنتجات",
      btnQuote: "طلب تسعير حاوية / B2B",
    },
    stats: {
      s1: "قطعة غيار مشحونة",
      s2: "قطع أصلية ومكفولة",
      s3: "دولة موردة ومصنعة",
      s4: "عميل وموزع جملة",
    },
    home: {
      finderTitle: "🔍 ابحث عن قطعة الغيار المناسبة لسيارتك",
      finderBrand: "اختر ماركة السيارة (Brand)",
      finderModel: "اكتب موديل السيارة أو السنة (مثلاً: 2020)",
      finderBtn: "بحث عن القطع",
      featuredTitle: "الأكثر طلباً في الشحنات الأخيرة",
      featuredDesc: "قطع غيار أصلية ومكفولة مستوردة مباشرة من المصنعين بحالة ممتازة",
      viewAll: "استكشف الكتالوج بالكامل",
      whyTitle: "لماذا نحن خيارك الأول في الاستيراد؟",
      whyDesc: "نضمن لك سلاسة في التوريد وبأعلى معايير الأمان والجودة العالمية",
      why1Title: "شحن بحري وجوي سريع",
      why1Desc: "نوفر خيارات شحن متعددة تناسب حجم تجارتك مع متابعة دقيقة لمسار الشحنة حتى وصولها للميناء.",
      why2Title: "ضمان فحص الجودة (QC)",
      why2Desc: "فحص شامل لكافة شحنات قطع الغيار من المصدر في اليابان وألمانيا قبل التعبئة والشحن.",
      why3Title: "أسعار تنافسية B2B",
      why3Desc: "تعاقدات مباشرة مع المصانع العالمية تمنحك أفضل هامش ربحي وتخفيضات للكميات الكبيرة.",
      why4Title: "تسهيلات التخليص الجمركي",
      why4Desc: "فريق متخصص لإنهاء كافة الأوراق الجمركية والشهادات والمطابقات بسرعة وسلاسة.",
      brandsTitle: "نستورد قطع غيار لأشهر الماركات العالمية",
      testimonialsTitle: "ماذا يقول شركاؤنا والتجار؟",
      t1: "\"تعاملنا مع الشركة في استيراد 3 حاويات قطع غيار فرامل من كوريا، الالتزام بالمواعيد والجودة كان ممتاز جداً.\"",
      t1Author: "- م. أحمد سليمان (موزع قطع غيار)",
      t2: "\"خدمة تتبع الشحنات وطلب التسعير تسهل علينا الكثير من الوقت. أفضل شريك استيراد نعتمد عليه.\"",
      t2Author: "- مركز العالمية لخدمة السيارات",
      ctaTitle: "جاهز لبدء طلب شحنتك الخاصة؟",
      ctaDesc: "أرسل لنا تفاصيل القطع المطلوبة وحجم الشحنة، وسيزودك فريق المبيعات بتسعير شامل خلال 24 ساعة.",
      ctaBtn1: "طلب تسعير شحنة جملة",
      ctaBtn2: "التحدث مع خبير استيراد",
    },
    process: {
      title: "إزاي بتتم عملية الاستيراد معانا؟",
      desc: "خطوات واضحة ومنظمة من لحظة الطلب لحد استلام شحنتك",
      step1Title: "1. إرسال الطلب",
      step1Desc: "ترسل تفاصيل القطع المطلوبة والكمية عبر فورم طلب التسعير أو تواصل مباشر مع فريق المبيعات.",
      step2Title: "2. تأكيد السعر والتعاقد",
      step2Desc: "نرسل عرض سعر تفصيلي شامل الشحن والجمارك، وبعد الموافقة يتم توقيع الاتفاق.",
      step3Title: "3. فحص الجودة والتعبئة",
      step3Desc: "فريقنا في المصدر يفحص القطع فحصاً كاملاً قبل التعبئة والشحن لضمان مطابقتها للمواصفات.",
      step4Title: "4. الشحن والتخليص الجمركي",
      step4Desc: "نتابع شحنتك أولاً بأول وننهي كل إجراءات التخليص الجمركي نيابة عنك حتى تصل بسلاسة.",
      step5Title: "5. التسليم النهائي",
      step5Desc: "تستلم شحنتك في الموعد المتفق عليه مع كافة الفواتير والشهادات الرسمية.",
    },
    faq: {
      title: "الأسئلة الشائعة",
      desc: "إجابات على أكثر الأسئلة اللي بتوصلنا من عملائنا وشركائنا",
      q1: "إيه أقل كمية تقدروا تصدروها أو تستوردوها؟",
      a1: "بنتعامل مع الكميات الكبيرة والجملة بشكل أساسي، ولكن نوفر أيضاً حلول لأصحاب المحلات بكميات أصغر حسب نوع القطعة والاتفاق.",
      q2: "قد إيه بياخد وقت الشحن من بلد المنشأ لمصر؟",
      a2: "يختلف حسب الدولة ونوع الشحن (بحري أو جوي)، لكن غالباً بين 15 إلى 30 يوم للشحن البحري من اليابان أو كوريا.",
      q3: "هل بتتكفلوا بالتخليص الجمركي؟",
      a3: "أيوه، فريقنا المتخصص بيتابع كل إجراءات التخليص الجمركي والشهادات نيابة عن العميل بالكامل.",
      q4: "هل القطع مضمونة ولها ضمان؟",
      a4: "كل القطع اللي بنستوردها أصلية ومصحوبة بشهادات مطابقة، وبتتفحص فحص جودة كامل قبل الشحن.",
    },
    about: {
      title: "من نحن",
      subtitle: "شركاء الاستيراد الموثوقون للتجار والموزعين في مصر والشرق الأوسط",
      visionTitle: "رؤيتنا وتخصصنا",
      visionP1: "Global Auto Parts شركة متخصصة في استيراد وتصدير قطع غيار السيارات الأصلية والمعتمدة من كبرى المصانع العالمية في اليابان، ألمانيا، وكوريا الجنوبية.",
      visionP2: "نخدم أسواق الجملة والتوزيع بكفاءة عالية، ونوفر حلول شحن كاملة من الباب للميناء مع دعم التخليص الجمركي.",
      feat1Title: "🌍 شبكة موردين عالمية",
      feat1Desc: "علاقات مباشرة مع أكثر من 50 مصنعاً في 25 دولة حول العالم.",
      feat2Title: "✅ قطع أصلية مضمونة",
      feat2Desc: "كل قطعة مصحوبة بشهادات أصالة ومطابقة معايير الجودة الدولية.",
      feat3Title: "⚡ تسليم في الوقت المحدد",
      feat3Desc: "جداول شحن منتظمة وخطوط ملاحية مباشرة تضمن وصول بضاعتك في الموعد.",
    },
    productsPage: {
      title: "كتالوج قطع الغيار",
      subtitle: "تصفح وابحث في مئات القطع الأصلية المتاحة للاستيراد الفوري والطلب المسبق",
      filterTitle: "فلترة المنتجات",
      category: "الفئة",
      brand: "الماركة",
      inStockOnly: "المتوفر في المخزن فقط",
      searchPlaceholder: "ابحث بالاسم أو رقم OEM أو الماركة...",
      noResults: "لا توجد نتائج تطابق بحثك",
      noResultsDesc: "جرب تغيير فلاتر البحث أو اسم القطعة.",
    },
    productCard: {
      origin: "بلد المنشأ:",
      oem: "رقم القطعة (OEM):",
      inStock: "متوفر بالمخزن",
      importOrder: "طلب استيراد",
      details: "التفاصيل",
    },
    productDetails: {
      notFound: "المنتج غير موجود!",
      backBtn: "العودة للكتالوج",
      brand: "الماركة:",
      compatibleModels: "الموديلات المتوافقة:",
      allModels: "جميع الموديلات",
      quoteBtn: "طلب تسعير للشحنات",
      contactBtn: "تواصل مع المبيعات",
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "فريق المبيعات والدعم متاح 6 أيام في الأسبوع",
      infoTitle: "بيانات التواصل",
      formTitle: "أرسل رسالتك",
      address: "📍 القاهرة، مصر - منطقة التجمع الخامس",
      phone: "📞 +20 100 000 0000",
      email: "✉️ info@globalautoparts.com",
      hours: "🕐 السبت - الخميس: 9 صباحاً - 6 مساءً",
      namePlace: "الاسم الكامل",
      emailPlace: "البريد الإلكتروني",
      subjectPlace: "الموضوع",
      msgPlace: "اكتب رسالتك...",
      sendBtn: "إرسال الرسالة",
    },
    track: {
      title: "تتبع شحنتك",
      subtitle: "أدخل رقم الشحنة أو الـ Bill of Lading لمعرفة الحالة الحالية",
      placeholder: "أدخل رقم الشحنة أو B/L...",
      btn: "تتبع الآن",
      resultTitle: "نتيجة تتبع الشحنة:",
      state: "الحالة:",
      origin: "ميناء المنشأ:",
      destination: "الميناء المستهدف:",
      estDelivery: "الوصول المتوقع:",
      defaultState: "في الطريق — عبور ميناء سنغافورة",
      defaultOrigin: "ميناء يوكوهاما — اليابان",
      defaultDest: "ميناء الإسكندرية — مصر",
      defaultDate: "خلال 18 - 22 يوم",
    },
    quote: {
      title: "طلب تسعير شحنة جملة",
      subtitle: "أرسل تفاصيل طلبك وسيتواصل معك فريق المبيعات خلال 24 ساعة",
      company: "اسم الشركة / المحل",
      name: "اسم المسؤول",
      phone: "رقم الهاتف / الواتساب",
      partType: "نوع القطعة أو الرقم الأصلي (OEM)",
      partPlaceholder: "مثال: فحمات فرامل Toyota Corolla 2020",
      quantity: "الكمية المطلوبة أو حجم الحاوية",
      qtyPlaceholder: "مثال: 500 طقم أو حاوية 20 قدم",
      notes: "ملاحظات إضافية",
      submitBtn: "إرسال طلب التسعير",
      alertMsg: "✅ تم استلام طلبك! سيتواصل معك فريقنا خلال 24 ساعة.",
    },
    footer: {
      desc: "الشريك الموثوق لاستيراد وتوريد قطع غيار السيارات من مصانع عالمية معتمدة.",
      quickLinks: "روابط سريعة",
      contactUs: "تواصل معنا",
      rights: "© جميع الحقوق محفوظة",
    },
  },

  en: {
    nav: {
      subTitle: "Certified Importers & Exporters",
      home: "Home",
      about: "About Us",
      products: "Products",
      track: "Track Order",
      quote: "Request Quote",
      contact: "Contact",
      langBtn: "عربي",
    },
    hero: {
      badge: "Leaders in Supply & Import ⚓",
      title: "Complete Solutions for Auto Parts Import & Export",
      desc: "We connect your business with the world's largest auto parts manufacturers in Japan, Germany, and Korea. We offer direct shipping for bulk orders at factory prices with certified warranties.",
      btnProducts: "Browse Products",
      btnQuote: "Request Container Quote / B2B",
    },
    stats: {
      s1: "Parts Shipped",
      s2: "Original & Guaranteed Parts",
      s3: "Supplier Countries",
      s4: "Wholesale Clients",
    },
    home: {
      finderTitle: "🔍 Find the Right Part for Your Car",
      finderBrand: "Select Car Brand",
      finderModel: "Enter model or year (e.g. 2020)",
      finderBtn: "Search Parts",
      featuredTitle: "Most Requested in Recent Shipments",
      featuredDesc: "Original, guaranteed auto parts imported directly from manufacturers in excellent condition",
      viewAll: "Explore Full Catalog",
      whyTitle: "Why Choose Us for Importing?",
      whyDesc: "We guarantee a smooth supply process with the highest global safety and quality standards",
      why1Title: "Fast Sea & Air Freight",
      why1Desc: "Multiple shipping options tailored to your business volume with precise tracking until port arrival.",
      why2Title: "Quality Control Guarantee (QC)",
      why2Desc: "Comprehensive inspection of all auto parts shipments at the source in Japan and Germany before packing and shipping.",
      why3Title: "Competitive B2B Pricing",
      why3Desc: "Direct contracts with global manufacturers give you the best profit margin and bulk discounts.",
      why4Title: "Customs Clearance Facilitation",
      why4Desc: "Specialized team to complete all customs paperwork, certificates, and conformity requirements quickly and smoothly.",
      brandsTitle: "We Import Parts for the World's Top Brands",
      testimonialsTitle: "What Our Partners & Dealers Say",
      t1: '"We worked with the company to import 3 containers of brake parts from Korea. Punctuality and quality were excellent."',
      t1Author: "- Eng. Ahmed Suleiman (Auto Parts Distributor)",
      t2: '"The shipment tracking and quote request service saves us a lot of time. The best import partner we rely on."',
      t2Author: "- Al-Alamiya Auto Service Center",
      ctaTitle: "Ready to Start Your Own Shipment Order?",
      ctaDesc: "Send us the required part details and shipment volume, and our sales team will provide a comprehensive quote within 24 hours.",
      ctaBtn1: "Request Wholesale Shipment Quote",
      ctaBtn2: "Talk to an Import Expert",
    },
    process: {
      title: "How Our Import Process Works",
      desc: "Clear, organized steps from the moment you order until your shipment arrives",
      step1Title: "1. Submit Your Request",
      step1Desc: "Send us the part details and quantity you need through the quote form or by contacting our sales team directly.",
      step2Title: "2. Price Confirmation & Agreement",
      step2Desc: "We send a detailed quote including shipping and customs costs, and sign the agreement upon your approval.",
      step3Title: "3. Quality Check & Packing",
      step3Desc: "Our team at the source thoroughly inspects the parts before packing and shipping to ensure they meet specifications.",
      step4Title: "4. Shipping & Customs Clearance",
      step4Desc: "We track your shipment closely and handle all customs clearance procedures on your behalf until it arrives smoothly.",
      step5Title: "5. Final Delivery",
      step5Desc: "You receive your shipment on the agreed date along with all official invoices and certificates.",
    },
    faq: {
      title: "Frequently Asked Questions",
      desc: "Answers to the most common questions from our clients and partners",
      q1: "What's the minimum quantity you can export or import?",
      a1: "We mainly deal with bulk and wholesale quantities, but we also offer solutions for shop owners with smaller quantities depending on the part type and agreement.",
      q2: "How long does shipping take from the origin country to Egypt?",
      a2: "It varies by country and shipping method (sea or air), but typically ranges from 15 to 30 days for sea freight from Japan or Korea.",
      q3: "Do you handle customs clearance?",
      a3: "Yes, our specialized team handles all customs clearance procedures and certificates on behalf of the client entirely.",
      q4: "Are the parts guaranteed and warrantied?",
      a4: "All parts we import are original and come with conformity certificates, and undergo full quality inspection before shipping.",
    },
    about: {
      title: "About Us",
      subtitle: "Trusted import partners for traders and distributors in Egypt and the Middle East",
      visionTitle: "Our Vision & Specialty",
      visionP1: "Global Auto Parts is a company specialized in importing and exporting original and certified auto parts from major global manufacturers in Japan, Germany, and South Korea.",
      visionP2: "We serve wholesale and distribution markets with high efficiency, providing complete shipping solutions from door to port with customs clearance support.",
      feat1Title: "🌍 Global Supplier Network",
      feat1Desc: "Direct relationships with over 50 manufacturers in 25 countries worldwide.",
      feat2Title: "✅ Guaranteed Original Parts",
      feat2Desc: "Every part comes with authenticity certificates and international quality standard compliance.",
      feat3Title: "⚡ On-Time Delivery",
      feat3Desc: "Regular shipping schedules and direct shipping lanes ensure your goods arrive on time.",
    },
    productsPage: {
      title: "Auto Parts Catalog",
      subtitle: "Browse and search hundreds of original parts available for immediate import and pre-order",
      filterTitle: "Filter Products",
      category: "Category",
      brand: "Brand",
      inStockOnly: "In Stock Only",
      searchPlaceholder: "Search by name, OEM number or brand...",
      noResults: "No matching results found",
      noResultsDesc: "Try resetting filters or search terms.",
    },
    productCard: {
      origin: "Origin:",
      oem: "OEM Number:",
      inStock: "In Stock",
      importOrder: "Import Order",
      details: "Details",
    },
    productDetails: {
      notFound: "Product not found!",
      backBtn: "Back to Catalog",
      brand: "Brand:",
      compatibleModels: "Compatible Models:",
      allModels: "All Models",
      quoteBtn: "Request Shipment Quote",
      contactBtn: "Contact Sales",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Sales and support team available 6 days a week",
      infoTitle: "Contact Information",
      formTitle: "Send Your Message",
      address: "📍 Cairo, Egypt - New Cairo District",
      phone: "📞 +20 100 000 0000",
      email: "✉️ info@globalautoparts.com",
      hours: "🕐 Saturday - Thursday: 9 AM - 6 PM",
      namePlace: "Full Name",
      emailPlace: "Email Address",
      subjectPlace: "Subject",
      msgPlace: "Write your message...",
      sendBtn: "Send Message",
    },
    track: {
      title: "Track Your Shipment",
      subtitle: "Enter your shipment number or Bill of Lading to check current status",
      placeholder: "Enter shipment number or B/L...",
      btn: "Track Now",
      resultTitle: "Tracking Result:",
      state: "Status:",
      origin: "Origin Port:",
      destination: "Destination Port:",
      estDelivery: "Estimated Arrival:",
      defaultState: "In Transit — Passing Singapore Port",
      defaultOrigin: "Yokohama Port — Japan",
      defaultDest: "Alexandria Port — Egypt",
      defaultDate: "Within 18 - 22 days",
    },
    quote: {
      title: "Request Wholesale Shipment Quote",
      subtitle: "Send your order details and our sales team will contact you within 24 hours",
      company: "Company / Shop Name",
      name: "Contact Person Name",
      phone: "Phone / WhatsApp Number",
      partType: "Part Type or OEM Number",
      partPlaceholder: "e.g. Toyota Corolla 2020 Brake Pads",
      quantity: "Required Quantity or Container Size",
      qtyPlaceholder: "e.g. 500 sets or 20ft container",
      notes: "Additional Notes",
      submitBtn: "Submit Quote Request",
      alertMsg: "✅ Your request has been received! Our team will contact you within 24 hours.",
    },
    footer: {
      desc: "Your trusted partner for importing and supplying auto parts from certified global manufacturers.",
      quickLinks: "Quick Links",
      contactUs: "Contact Us",
      rights: "© All Rights Reserved",
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("ar");

  const toggleLanguage = () => {
    setLang((prev) => (prev === "ar" ? "en" : "ar"));
  };

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}